module.exports = __webpack_public_path__ + "img/1280x720-Christmas.9801d6c0.jpg";